import { PHYSICAL_QTY_MAX_FOR_B2B, PHYSICAL_QTY_MAX_FOR_B2C } from '@config/constants';
import { config } from '../config/config';

interface HiConsistsOfItem {
  biiSalable: {
    wEditionFormat: string;
  };
}
interface BulkOrderResult {
  isAllowed: boolean;
  maxQty: number;
}

export const hasPhysicalProducts = (items: HiConsistsOfItem[]): boolean => {
  return items.some(
    (item) => item.biiSalable.wEditionFormat === 'PHYSICAL'
      || item.biiSalable.wEditionFormat === 'DIGITAL_AND_PHYSICAL',
  );
};

const getPhysicalMaxQty = (sku: string): number => {
  return config.b2b_available_products.includes(sku) ? PHYSICAL_QTY_MAX_FOR_B2B : PHYSICAL_QTY_MAX_FOR_B2C;
};

export const isBulkOrder = (sku: string): BulkOrderResult => {
  const maxQty = getPhysicalMaxQty(sku);
  return {
    isAllowed: maxQty > PHYSICAL_QTY_MAX_FOR_B2C,
    maxQty,
  };
};
